<template>
  <base-page
    :title="$t('common.divisions.plural')"
  >
    <template #actionButton>
      <division-create-update-dialog>
        <template v-slot:activator="{ on }">
          <v-btn
            rounded
            outlined
            color="primary"
            v-on="on"
          >
            <v-icon>add</v-icon> Add {{ $t('common.divisions.singular') }}
          </v-btn>
        </template>
      </division-create-update-dialog>
    </template>
    <template #main>
      <division-list />
    </template>
  </base-page>
</template>

<script>
import { mapActions } from 'vuex'
import DivisionList from '@/components/Division/DivisionList.vue'
import DivisionCreateUpdateDialog from "../../components/Division/DivisionCreateUpdateDialog"

import BasePage from "../BasePage"

export default {
  components: {
    DivisionList,
    BasePage,
    DivisionCreateUpdateDialog
  },
  created() {
    this.initDivisions()
  },
  methods: {
    ...mapActions(['initDivisions'])
  }
}
</script>
